import React from 'react';
import './Home.css';
import logo from './logo.png';
import { Link } from 'react-router-dom';

const Home = () => {
    let token = localStorage.getItem("token") ? localStorage.getItem("token") : null;
    let data = token ?  JSON.parse(atob(token.split('.')[1])) : {};
    let id = localStorage.getItem("userid");
    
    return (
        <>

            <div className='main'>

                <div className='right'>
                    <img src={logo} alt="GOLDEN TOUCH" />
                </div>

                <div className='left container'>
                    <h1 className='text-gold'>GOLDEN TOUCH</h1>
                    <h1 className='text-gold'>BEAUTY SALOON</h1>
                    <p className='text-gold' style={{fontSize: '18px'}}>Me rezervimin e termineve nese hapni llogari ne faqen tone, do te keni shperblime te ndryshme</p>
                    <div className='button-group'>
                        <button className='button-black' style={{border: '2px solid #a86c19'}}> <a className='clean-a' href='/termin'> REZERVO </a> </button>
                        <button className='button-gold' style={{backgroundColor:'#a86c19'}}><a className='clean-a-gold' href='/auth/login'> LOG IN </a></button>
                    </div>    
                </div>

            </div>
        </>
    )
}

export default Home;
